<template>
  <div class="column is-12">
    <div class="card">
      <header class="header-card">
        <p>
          {{$t('societes.delaiAdministratif.title')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column is-5 is-4-fullhd">
            <b-field :label="$t('societes.delaiAdministratif.vente')"
                     class="obligatoire">
              <b-input type="number"
                       v-model="societe.delaiAdministratifVente">
              </b-input>
            </b-field>
          </div>
          <div class="column is-5 is-4-fullhd">
            <b-field :label="$t('societes.delaiAdministratif.achat')"
                     class="obligatoire">
              <b-input type="number"
                       v-model="societe.delaiAdministratifAchat">
              </b-input>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
};
</script>
